import { trimEnd } from 'lodash';
import { Node_Type } from 'ricos-schema';
import { getPostCover as _getPostCover, getPostVideoEmbedCover as _getPostVideoEmbedCover, } from '@wix/communities-universal/dist/src/services/get-post-cover';
import { POST_SEO_DESCRIPTION_MAXLENGTH } from '../../constants';
import { getRichContentPostVideoEmbedCover, getVideoUrl, isRichContent, limitLength, removeTrailingSlash, resizeThumbnail, } from '../../services';
import { getMultilingualQueryParam } from '../../services/get-multilingual-query-param';
import { getRichContentText } from '../../services/get-rich-content-text';
import { getRichContentPostCover } from '../../services/post-cover-utils';
export { getPostImageCover } from '@wix/communities-universal/dist/src/services/get-post-cover';
const getHelpers = (imageHost, videoHost) => ({
    resizeThumbnail: (pathname, width, height) => resizeThumbnail({ pathname, width, height, imageHost }),
    getVideoUrl: (pathname) => getVideoUrl({ pathname, videoHost }),
});
export const getPostCover = (post, imageHost, videoHost) => {
    return imageHost && videoHost && post.content
        ? isRichContent(post.content)
            ? getRichContentPostCover({ content: post.content }, imageHost, videoHost)
            : _getPostCover(post, getHelpers(imageHost, videoHost))
        : post?.coverImage ?? {};
};
export const getPostVideoEmbedCover = (post, imageHost, videoHost) => {
    const postContent = post.content ?? {};
    if (isRichContent(postContent)) {
        return getRichContentPostVideoEmbedCover(postContent, imageHost, videoHost);
    }
    return _getPostVideoEmbedCover(post, getHelpers(imageHost, videoHost));
};
export const getPostExcerpt = ({ excerpt, content, }) => {
    if (excerpt) {
        return limitLength(excerpt, POST_SEO_DESCRIPTION_MAXLENGTH);
    }
    return limitLength(getRichContentText({
        ...content,
        nodes: content.nodes.filter((node) => node.type !== Node_Type.IMAGE),
    }), POST_SEO_DESCRIPTION_MAXLENGTH);
};
export const getPostSeoDescription = ({ content, excerpt, seoDescription, }) => limitLength(seoDescription || getPostExcerpt({ excerpt, content }), POST_SEO_DESCRIPTION_MAXLENGTH);
export const getPostAmpUrl = (postId, ampBaseUrl, postSlug) => {
    if (!ampBaseUrl || !postId || !postSlug) {
        return;
    }
    return `${removeTrailingSlash(ampBaseUrl)}/${removeTrailingSlash(postSlug)}`;
};
export const getCanonicalPostUrl = ({ post, postPageSectionUrl, customPostUrl, multilingual, }) => {
    if (customPostUrl) {
        const langParam = multilingual
            ? getMultilingualQueryParam(multilingual)
            : '';
        return `${customPostUrl}${langParam}`;
    }
    if (post.url) {
        return `${post.url.base}${post.url.path}`;
    }
    if (post.canonicalUrl) {
        return post.canonicalUrl;
    }
    return `${trimEnd(postPageSectionUrl, '/')}/${post.slug}`;
};
//# sourceMappingURL=post-selectors.js.map